import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-annotations',
  templateUrl: './help-annotations.component.html'
})
export class HelpAnnotationsComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
  }
  annot_header;
  annot_description;
  annot_para1header;
  annot_para1body;
  annot_para2header;
  annot_para2body;
  annot_para2SubHeader;
  annot_para2BodyList;
  annot_para2BodyEnd;
  annot_para3SubHeader;
  annot_para3Body;

  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
    
    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.getannotationlabels();
  }
  annot_para3Header;
  annot_para3BodyList;
  annot_para4SubHeader;
  annot_para4Body;
  annot_para4BodyList;
  getannotationlabels() {
    this.graphQlService.getHelp_Annotationlabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.annot_header = labels.filter(x => x.key == "annot_header").map(y => y.value);
        this.annot_description = labels.filter(x => x.key == "annot_description").map(y => y.value);
        this.annot_para1header = labels.filter(x => x.key == "annot_para1header").map(y => y.value);
        this.annot_para1body = labels.filter(x => x.key == "annot_para1body").map(y => y.value);
        this.annot_para2header = labels.filter(x => x.key == "annot_para2header").map(y => y.value);
        this.annot_para2body = labels.filter(x => x.key == "annot_para2body").map(y => y.value);


        this.annot_para2SubHeader = labels.filter(x => x.key == "annot_para2SubHeader").map(y => y.value);
        this.annot_para2BodyList = labels.filter(x => x.key == "annot_para2BodyList").map(y => y.value);
        this.annot_para2BodyEnd = labels.filter(x => x.key == "annot_para2BodyEnd").map(y => y.value);
        this.annot_para3SubHeader = labels.filter(x => x.key == "annot_para3SubHeader").map(y => y.value);
        this.annot_para3Body = labels.filter(x => x.key == "annot_para3Body").map(y => y.value);


        this.annot_para4SubHeader = labels.filter(x => x.key == "annot_para4SubHeader").map(y => y.value);
        this.annot_para4Body = labels.filter(x => x.key == "annot_para4Body").map(y => y.value);
        this.annot_para4BodyList = labels.filter(x => x.key == "annot_para4BodyList").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }


}
